import { graphql, type ResultOf } from 'graphql-schema';

export type GetRentalGeneralInfoData = ResultOf<typeof GET_RENTAL_GENERAL_INFO>;

const GET_RENTAL_GENERAL_INFO = graphql(`
  query rental($rentalId: uuid!) {
    rental: rentals_by_pk(_id: $rentalId) {
      _id
      standard_price_cents
      prime_price_cents
      first_timeslot_by_time: timeslots(order_by: { start_time: asc }, limit: 1) {
        _id
        start_time_str
      }
      last_timeslot_by_time: timeslots(order_by: { start_time: desc }, limit: 1) {
        _id
        end_time_str
      }
      venue: venueByVenue {
        _id
        shorthand_name
        neighborhoodByNeighborhoodId {
          _id
          name
        }
        venue_map_url
        formatted_address
        latitude
        longitude
        place_id
      }
    }
  }
`);

export default GET_RENTAL_GENERAL_INFO;
